export { default } from './PaymentDetails'
export * as S from './PaymentDetails.styles'
